export const Tabs = [
  {
    name: "Women's",
    title: "Women's World Tennis Tour",
    class: "primary",
    tourCode: "WT"
  },
  {
    name: "Men's",
    title: "Men's World Tennis Tour",
    class: "primary",
    tourCode: "MT"
  },
  {
    name: "Juniors",
    title: "World Tennis Tour Juniors",
    class: "primary",
    tourCode: "JT"
  },
  {
    name: "Masters",
    title: "World Tennis Masters Tour",
    class: "masters",
    tourCode: "VT"
  },
  {
    name: "Wheelchair",
    title: "Wheelchair Tennis Tour",
    class: "secondary",
    tourCode: "WCT"
  },
  {
    name: "Beach",
    title: "Beach Tennis World Tour",
    class: "tertiary",
    tourCode: "BT"
  }
];
